import { defineMessages, messagesNow, pickMessages } from '@/i18n'
import type { Lang } from '@/types/lang'

const messages = defineMessages({
  ru: { untitled: 'Без названия' },
  en: { untitled: 'Untitled' },
})

/**
 * Подпись курса без названия — на языке интерфейса. Это ПОКАЗ, а не значение:
 * в данные она не пишется, поэтому пустое название так и считается пустым
 * (проверка публикации попросит его ввести). Где можно, её красят серым.
 */
export const untitledLabel = (lang?: Lang): string =>
  (lang ? pickMessages(messages, lang) : messagesNow(messages)).untitled
